import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/Authcontext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import star from "../assets/star.svg";

import search from "../assets/searsh.svg";

const Alltrainings = () => {
  const { contextData } = useContext(AuthContext);
  const navigate = useNavigate();
  const [formations, setformations] = useState([]);
  const [formationsfiltered, setformationsfiltered] = useState([]);
  let [imageUrl, setImageUrl] = useState([]);
  const [topics, settopics] = useState([]);
  const [didsearch, setdidsearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [refresh, setrefresh] = useState(true);
  const [notfound, setnotfound] = useState(false);

  const gettopics = async () => {
    const { data } = await axios.get(
      "https://pfebackend-zbz0.onrender.com/api/topics/"
    );
    settopics(data);
  };

  const getFiles = async (ids) => {
    const responses = await Promise.all(
      ids.map(async (id) => {
        const response = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/formations/image/${id}/`,
          {
            responseType: "blob",
          }
        );
        return response.data;
      })
    );

    const blobs = responses.map((response) => new Blob([response]));
    let urls = blobs.map((blob) => window.URL.createObjectURL(blob));

    for (let i = 0; i < urls.length; i++) {
      // const image = document.getElementById(`image-${i}`);
      const image = document.getElementsByClassName(`${ids[i]}`);
      for (let j = 0; j < image.length; j++) {
        image[j].src = urls[i];
      }
      // image.src = urls[i];
    }
  };

  const getformations = async () => {
    let list = [];
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/formations/all`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setformations(responce.data);
    responce.data.map((e) => list.push(e.id));
    getFiles(list);
  };

  const handelshoseformation = async (e) => {
    if (contextData.user) {
      const { data } = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/user/formation/${e.id}/`,
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
      data
        ? navigate(`/formation/${e.id}/`)
        : navigate(`/formation/description/${e.id}/`);
    } else {
      navigate(`/formation/description/${e.id}/`);
    }
  };

  const handelsearchformation = async (e) => {
    if (e !== "") {
      const search = e;
      const { data } = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/formations/filter/${search}/`
      );

      setformations(data);
      if (data.length === 0) {
        setnotfound(true);
      } else {
        setnotfound(false);
      }

      let list = [];
      data.map((e) => list.push(e.id));
      getFiles(list);
      setrefresh(!refresh);
      if (e === "") {
      }
    } else {
      getformations();
      setnotfound(false);
    }
  };

  const handeltogle = () => {
    const dropdown = document.getElementById("bttngrp88");
    dropdown.classList.add("displayblock");

    const button = document.getElementById("btn-filter22");

    document.addEventListener("click", function (event) {
      if (event.target !== button && !button.contains(event.target)) {
        dropdown.classList.remove("displayblock");
      }
    });
  };

  useEffect(() => {
    getformations();
    gettopics();
  }, []);

  return (
    <>
      <div className="alltrainings-container">
        {errorMessage && (
          <div className=" erroremailexiste">{errorMessage}</div>
        )}

        <div className="alltrainings-header">
          <div className="pull-left course-filter">
            <div className="filter-label">Category:</div>
            <button
              onClick={handeltogle}
              id="btn-filter22"
              className="btn-filter dropdown-toggle"
              type="button"
            >
              All <span className="caret"></span>
            </button>
            <div id="bttngrp88" className=" displaynone btn-group">
              <ul className="dropdown-menu" role="menu" id="filter-dropdown">
                {topics.map((e, i) => {
                  return (
                    <li key={i} className="filter-item">
                      <a href={`/formations/categorie/${e.name}/`}>{e.name}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <div className="searchcontainer ">
            {/* onInput={handelsearchformation} */}
            <input
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              type="text"
              placeholder="Find a training"
              className="search-input"
              onInput={(event) => handelsearchformation(event.target.value)}
            />
            <div className="search-image-container">
              <img className="search-image" src={search} alt="" />
            </div>
          </div>
        </div>
        {/* {didsearch && formationsfiltered.length === 0 && (
        <div className="alert alert-danger" role="alert">
          no formation found
        </div>
      )} */}
        {notfound && (
          <div className="alert alert-danger" role="alert">
            no formation found
          </div>
        )}

        <div className="courses-container-all">
          {formations.map((e, i) => {
            return (
              <article
                onClick={() => handelshoseformation(e)}
                key={i}
                className="card"
              >
                {imageUrl ? (
                  <img
                    className={`card-image  ${e.id}`}
                    src={imageUrl}
                    id={`image-${i}`}
                    alt=""
                  />
                ) : (
                  <p>Loading image...</p>
                )}
                <div className="card-text-container">
                  <h5 className="card-title">{e.name}</h5>
                  <p className="card-discrition">
                    {e.description.substring(0, 70) + "..."}
                  </p>
                  <div className="rating-container">
                    <img className="star" src={star} alt="" />
                    <p className="rating">{e.rating}</p>
                  </div>
                  <p className="price">{e.price} Da</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Alltrainings;
